<script>
  export let avatar = '';
  export let title = '';
  export let desc = '';
</script>

<style>
  .user-banner {
    margin: 48px 0;
  }
  .avatar {
    border-radius: 40px;
  }
  .title {
    font-weight: bold;
    font-size: 32px;
    color: #fff;
  }
  .desc {
    padding-top: 8px;
    font-size: 16px;
    color: #fff;
  }
  .content {
    padding-left: 12px;
  }
  @media screen and (max-width: 640px) {
    .user-banner {
      margin: 12px 0;
    }
    .avatar {
      width: 48px;
      height: 48px;
    }
    .title {
      font-size: 20px;
    }
    .desc {
      padding-top: 4px;
      font-size: 14px;
    }
  }
</style>

<div class="user-banner df">
  <img class="avatar" width="80" height="80" src={avatar} />
  <div class="content">
    <div class="title">{@html title}</div>
    <div class="desc">{@html desc}</div>
  </div>
</div>
